export default {
    ordersLayout: {
        back: "Terug",
        emptyOrders: "Je hebt nog geen bestellingen.",
        loading: "Laden",
        storeLabel: "Winkel",
        totalLabel: "Totaal",
        storeAddressPending: "Adres volgt binnenkort",
        productNameFallback: "Product",
        ecListTitle: "Je bestellingen",
        ecStatusInStore: "Status: aankoop in de winkel",
        ecOrderNumber: "Bestelnummer: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} artikel: totaal {{amount}}",
        ecCountTotalOther: "{{count}} artikelen: totaal {{amount}}",
        ecViewOrder: "Bestelling bekijken >",
        ecViewOrderA11y: "Bestelling {{order_number}} bekijken",
        ecBackToOrders: "Terug naar je bestellingen",
        ecInStoreDate: "Aankoop in de winkel – {{date}}",
        ecProductsOne: "Product",
        ecProductsOther: "Producten",
        ecSku: "Ref. {{sku}}",
        ecQty: "Aantal: {{qty}}",
        ecWarrantyExpired: "Buiten garantie",
        ecWarrantyActive: "Onder garantie",
        ecSubtotalOne: "Subtotaal – {{count}} artikel",
        ecSubtotalOther: "Subtotaal – {{count}} artikelen",
    }
}



// WEBPACK FOOTER //
// ./src/locales/nl/index.js